export const CabinsColors: Record<string, string> = {
  economy: "#4caf50", // y
  premiumEconomy: "#2e7d32", // w
  business: "#0091ea", // j
  first: "#673ab7", // f
  nonStop: "#0091ea", // nonstop
};

export const CabinNameMap: Record<string, string> = {
  Economy: "economy",
  "Premium Economy": "premiumEconomy",
  "PremiumEconomy": "premiumEconomy",
  Business: "business",
  First: "first",
};

export const siteName = "AwardTool";
export const domainName = siteName.toLocaleLowerCase();

export const CabinMap: Record<string, string> = {
  y: "Economy",
  w: "Premium",
  j: "Business",
  f: "First",
};

export const CabinColorsMap: Record<string, string> = {
  y: CabinsColors.economy,
  w: CabinsColors.premiumEconomy,
  j: CabinsColors.business,
  f: CabinsColors.first,
};

export const FREE_MAX_HOTEL_VIEW = 5;

export const FLIGHT_BATCH_SIZE = 7;
export const MAX_FLIGHT_BATCH_SIZE = 8;

export const MAX_ROUTE_CITY_COUNT = 50;

export const MAX_PRO_DATE_RANGE = 15;

export const API_KEY = "";

export const PRO_REFERRAL_BONUS = 10;
export const FREE_REFERRAL_BONUS = 0.5;
export const REFEREE_BONUS = 2;

export const RATE_LIMIT_BETWEEN_REQUESTS = 2000 * 1;
export const RATE_LIMIT_BETWEEN_FIVE_REQUESTS = 1000 * 60;
export const RATE_LIMIT_BETWEEN_TWO_REQUESTS = 1000 * 6;

export const SHOW_COUNT_DOWN_LIMIT = 60 * 60 * 24 * 10 * 1000;

// Get current hostname
const host = window.location.hostname;
const PROD_HOSTS = [
  "www.awardtool.com",
  "awardtool.com",
  "main.awardtool.com",
  "awardsearchtool.com",
  "www.awardsearchtool.com",
  "www.awardsearchtool.com",
];
export const IsProd = PROD_HOSTS.includes(host);
// export const IsProd = true;

export const isLocal = host.includes("localhost");

export const HotelColors = {
  C80: "#388e3c",
  C50: "#4caf50",
  C20: "#0091ea",
  C00: "#f57f17",
};

export const bankBgColor = "#6c6c6c";
export const airlineBgColor = "#727272";
export const airlineDarkBg: string[] = [];
export const programDarkBg: string[] = ["QF", "SK"];

export const NEED_BACKGROUND_PROGRAM = [
  "DL",
  "KL",
  "AA",
  "TK",
  "AC",
  "SK",
  "BA",
  "NK",
  "TP",
  "B6",
  "QF",
  "VS",
  "AS",
  "UA",
  "AM",
  "VA",
  "EY",
  "SQ",
];

export const FlightAlertSlogan = "Set alerts for multiple days and airports with advanced filters.";
export const PanoramaAlertSlogan =
  "Set alerts for multiple regions, countries, airports and days. ";
export const HotelAlertSlogan = "Set alerts for your next fantastic stay ";

export const en_key = `ZazkH4wKKfkq/zQPfgM23k9kHzufbkwZHWzk2kZmKfA=`;
export const en_vi = `1234567891011120`;

export const HiddenRealTimeSearchProgram = [];

export const ROUTE_NUMBER_COUNT = 50000;

// 用户信息最大过期时间10分钟
export const USERINFO_EXPIRES_MAX_AGE = 10 * 60 * 1000 * 1000;

/** 最大更新时间 */
export const maxLastSeenTime = 3 * 60;
